// extracted by mini-css-extract-plugin
export default {"main_css_us":"InputNumber_main_css_us__fHWRO","main_css_jp":"InputNumber_main_css_jp__Zt5f3"};